import { useQuery } from '@apollo/client';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';

import GET_FEATURE_FLAG_BY_NAMEKEY from '../useFeatureFlagByNameKey/graphql/GetFeatureFlagByNameKey.v5.graphql';
import type {
  GetFeatureFlagByNameKey,
  GetFeatureFlagByNameKeyVariables,
} from './graphql/types/GetFeatureFlagByNameKey';

const useFeatureFlagByNameKey = (nameKey: string) => {
  const { organizationId } = useAdminDashboard();
  const { loading, error, data } = useQuery<
    GetFeatureFlagByNameKey,
    GetFeatureFlagByNameKeyVariables
  >(GET_FEATURE_FLAG_BY_NAMEKEY, {
    fetchPolicy: 'no-cache',
    variables: {
      nameKey,
      organizationId,
    },
    context: { clientName: 'v5' },
  });

  return {
    loading,
    error,
    valueFeatureFlag: Boolean(data?.feature_flag?.value),
  };
};

export default useFeatureFlagByNameKey;
